export const DEFAULT_UPLOAD_INPUT_ID = "upload-input";
